import * as types from '../constants/ActionTypes'
//import config from '../../config/app.js';

export default function practices(state = [], action) {
	switch (action.type) {
		case types.SET_PRACTICES:
			return action.payload


		case types.INSERT_PRACTICE:
			return state.concat([action.payload])

		case types.DELETE_PRACTICE:
			return state.filter(practice => practice._id !== action.payload);

		case types.UPDATE_PRACTICE:
			return state.map(p => {
				return p._id === action.payload._id ? action.payload : p
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/practices.js